var Forms = {
    HookFormsFn: hookFormsFn,
    HookAjaxFormsFn: hookAjaxFormsFn
};

var hookFormsFn = function ($forms) {

    $forms.each(function (j, form) {
        var $form = $(form);

        var validateOnKeyup = false;
        form.token = '';

        form.formUploadBoxesIds = {};
        form.formUploadBoxes = new Array();
        /*$(uploadBoxes).each(function (index, ub) {
            if ($form.find('#' + ub.id).length) {
                form.formUploadBoxes.push({
                    box: ub,
                    uploaded: false
                });
                form.formUploadBoxesIds[ub.id] = ub;
            }
        });*/

        var $rows = $('*.form-row.text, *.form-row.textarea, *.form-row.checkbox, *.form-row.select, *.form-row.uploads', $(form));
        $rows.each(function (r, row) {
            var $valField = $('*[data-member]:first', $(row));

            row.getValue = function () {
                if ($valField.length == 0)
                    return null;

                if ($valField.is(':text') || $valField.is(':password') || $valField.get(0).tagName.toLowerCase() == 'textarea' || $valField.get(0).tagName.toLowerCase() == 'select')
                    return $valField.val();
                else if ($valField.is(':checkbox'))
                    return $valField.is(':checked');
                else if ($($valField.get(0)).data('uploads')) {
                    return '';
                }

                return null;
            };

            row.setValue = function (value) {
                if ($valField.length == 0)
                    return;

                if ($valField.is(':text') || $valField.is(':password') || $valField.get(0).tagName.toLowerCase() == 'textarea' || $valField.get(0).tagName.toLowerCase() == 'select')
                    $valField.val(value);
                else if ($valField.is(':checkbox'))
                    $valField.prop('checked', value);
            };

            row.isValid = function () {
                if ($valField.length == 0)
                    return true;

                if ($valField.data('validaterequired')) {
                    if ($valField.is(':text') || $valField.is(':password') || $valField.get(0).tagName.toLowerCase() == 'textarea' || $valField.get(0).tagName.toLowerCase() == 'select') {
                        if ($valField.val().trim() === '') {
                            return false;
                        }
                    } else if ($valField.is(':checkbox')) {
                        var checked = $valField.is(':checked');
                        if (!checked)
                            return false;
                    } else if ($($valField.get(0)).data('uploads')) {
                        var s = 0;
                        var v = true;
                        $('*[data-upload-box]', $(row)).each(function (ii, ubi) {
                            var ub = form.formUploadBoxesIds[ubi.id];
                            if (ub.isFileSelected())
                                s++;
                            if (!ub.isValid()) {
                                v = false;
                                s--;
                            }
                        });
                        if (s < $form.data('required-files') || !v)
                            return false;
                    }
                }

                if ($valField.data('validateemail')) {
                    if ($valField.is(':text')) {
                        if (!LhApp.Function.String.isEmail($valField.val())) {
                            return false;
                        }
                    }
                }

                if ($valField.data('validatematch')) {
                    var group = $valField.data('validatematchgroup');
                    var groupedFields = $('*[data-member][data-validatematchgroup="' + group + '"]', $(form));
                    if (groupedFields.length > 0) {
                        var fieldValue = row.getValue();
                        var isMatchValid = true;

                        groupedFields.each(function (gi, gItem) {
                            if ($(gItem).is(':text') || $(gItem).is(':password')) {
                                if ($(gItem).val() != fieldValue) {
                                    isMatchValid = false;
                                }
                            } else if ($(gItem).is(':checkbox')) {
                                if ($(gItem).is(':checked') != fieldValue) {
                                    isMatchValid = false;
                                }
                            }
                        });

                        if (!isMatchValid) {
                            return false;
                        }
                    }
                }

                return true;
            };

            row.validate = function () {
                if ($valField.length == 0)
                    return true;

                $(row).removeClass('x-invalid');

                if ($valField.data('validaterequired')) {
                    var $validator = $('*[' + $valField.data('validaterequired') + ']', $(form));
                    $validator.siblings().hide();
                    $validator.hide();

                    if ($valField.is(':text') || $valField.is(':password') || $valField.get(0).tagName.toLowerCase() == 'textarea' || $valField.get(0).tagName.toLowerCase() == 'select') {
                        if ($valField.val().trim() === '') {
                            $(row).addClass('x-invalid');
                            $validator.show();
                            return;
                        }
                    } else if ($valField.is(':checkbox')) {
                        var checked = $valField.is(':checked');
                        if (!checked) {
                            $(row).addClass('x-invalid');
                            $validator.show();
                            return;
                        }
                    } else if ($($valField.get(0)).data('uploads')) {
                        var s = 0;
                        $('*[data-upload-box]', $(row)).each(function (ii, ubi) {
                            var ub = form.formUploadBoxesIds[ubi.id];
                            if (ub.isFileSelected()) {
                                s++;
                            }
                            if (!ub.validate()) {
                                s--;
                            }
                        });
                        if (s < $form.data('required-files')) {
                            $('*[data-upload-box]', $(row)).each(function (ii, ubi) {
                                var ub = form.formUploadBoxesIds[ubi.id];
                                ub.validateSelected();
                            });
                        }

                        if (!row.isValid()) {
                            $(row).addClass('x-invalid');
                            $validator.show();
                        }
                    }
                }

                if ($valField.data('validateemail')) {
                    var $validator = $('*[' + $valField.data('validateemail') + ']', $(form));
                    $validator.siblings().hide();
                    $validator.hide();

                    if ($valField.is(':text')) {
                        if (!LhApp.Function.String.isEmail($valField.val())) {
                            $(row).addClass('x-invalid');
                            $validator.show();
                            return;
                        }
                    }
                }

                if ($valField.data('validatematch')) {

                    var $validator = $('*[' + $valField.data('validatematch') + ']', $(form));
                    $validator.siblings().hide();
                    $validator.hide();

                    var group = $valField.data('validatematchgroup');
                    var groupedFields = $('*[data-member][data-validatematchgroup="' + group + '"]', $(form));
                    if (groupedFields.length > 0) {
                        var fieldValue = row.getValue();
                        var isMatchValid = true;

                        groupedFields.each(function (gi, gItem) {
                            if ($(gItem).is(':text') || $(gItem).is(':password') || $valField.get(0).tagName.toLowerCase() == 'textarea') {
                                if ($(gItem).val() != fieldValue) {
                                    isMatchValid = false;
                                }
                            } else if ($(gItem).is(':checkbox')) {
                                if ($(gItem).is(':checked') != fieldValue) {
                                    isMatchValid = false;
                                }
                            }
                        });

                        if (!isMatchValid) {
                            $(row).addClass('x-invalid');
                            $validator.show();
                            return;
                        }
                    }
                }
            };
        });

        form.fields = [];
        form.showLoader = function () {

            $('*[data-member]', $(form)).each(function (i, item) {
                if (!$(item).is(':disabled')) {
                    form.fields.push($(item).data('member'));
                    $(item).prop('disabled', true);
                }
            });

            $('*[data-click]', $(form)).each(function (i, item) {
                if (!$(item).is(':disabled')) {
                    $(item).prop('disabled', true);
                }
            });

            $form.find('.button-wrapper').addClass('x-disabled');
            $form.addClass('x-disabled');
            $form.addClass('x-loading');
        };

        form.hideLoader = function () {

            $('*[data-member]', $(form)).each(function (i, item) {
                if ($(item).is(':disabled')) {
                    if (form.fields.indexOf($(item).data('member')) != -1)
                        $(item).prop('disabled', false);
                }
            });

            $('*[data-click]', $(form)).each(function (i, item) {
                if ($(item).is(':disabled')) {
                    $(item).prop('disabled', false);
                }
            });

            $form.find('.button-wrapper').removeClass('x-disabled');
            $form.removeClass('x-disabled');
            $form.removeClass('x-loading');
        };

        form.isLoading = function () {
            return $form.hasClass('x-disabled');
        };

        form.validate = function () {
            $rows.each(function (r, row) {
                row.validate();
            });
            validateOnKeyup = true;
        };

        form.isValid = function () {
            var valid = true;

            $rows.each(function (r, row) {
                if (!row.isValid())
                    valid = false;
            });

            return valid;
        };

        form.reset = function () {
            $('*[data-section="success"]', $(form)).hide();
            $('*[data-section="failure"]', $(form)).hide();
            $('*[data-section="content"]', $(form)).show();


            $('input[type="file"][data-member]', $(form)).val('');
            $('input[type="text"][data-member]', $(form)).val('');
            $('input[type="password"][data-member]', $(form)).val('');
            $('input[type="textarea"][data-member]', $(form)).val('');
            $('input[type="checkbox"][data-member]', $(form)).prop('checked', false);

            $('*[data-validator]', $(form)).hide();
            $('*[data-validationmsg]', $(form)).hide();
        };

        $('*[data-member]', $(form)).keyup(function (e) {
            if ($(this).data("member") == "message") {
                $(this).keydown(preventSpecialCharacter);
            }

            if (!validateOnKeyup)
                return;

            var $row = $(this).parents('.form-row:first');
            $row.get(0).validate();
        });

        $('select[data-member]', $(form)).change(function (e) {
            if (!validateOnKeyup)
                return;

            var $row = $(this).parents('.form-row:first');
            $row.get(0).validate();
        });

        $('*[data-input]', $('*[data-uploads]', $(form))).change(function (e) {
            $('*[data-upload-box]', $(form)).each(function (i, ub) {
                var ub = form.formUploadBoxesIds[ub.id];
                ub.update();
                if (!validateOnKeyup)
                    ub.validate();
            })

            if (!validateOnKeyup)
                return;
            var $row = $(this).parents('.form-row:first');
            $row.get(0).validate();
        });

        $('*[data-trigger]', $(form)).keyup(function (e) {
            if (e.keyCode == 13) {
                e.stopPropagation();
                e.preventDefault();

                if (!form.isValid()) {
                    form.validate();
                    return;
                }

                if (form.isLoading())
                    return;

                var configData = form.getConfig();
                form.submit(configData);
            }
        });

        $('*[data-click="submit"]', $(form)).click(function (e) {
            e.preventDefault();

            if (!form.isValid()) {
                form.validate();
                return;
            }

            var isDisabled = form.isLoading() || LhApp.Function.isButtonDisabled(this);
            if (isDisabled)
                return;

            var configData = form.getConfig();
            form.submit(configData);
        });

        // submit customForm
        $('*[data-click="generic-submit"]', $(form)).click(function (e) {
            var code = $(form).data('code');

            e.preventDefault();
            form.validate();
            if (!form.isValid()) {
                return;
            }

            var isDisabled = form.isLoading() || LhApp.Function.isButtonDisabled(this);
            if (isDisabled)
                return;

            form.token = generateVisitorToken();
            $(form.formUploadBoxes).each(function (index, fub) {
                if (fub.box.input.val().length < 1) {
                    fub.uploaded = true;
                } else {
                    fub.uploaded = false;
                    fub.box.initCallback = function (box, token) {
                        $(form.formUploadBoxes).each(function (ii, bb) {
                            if (bb.box.id == box.id) {
                                $('*[data-progress-bar-box]', $(bb.box)).show();
                            }
                        });
                    };
                    fub.box.successCallback = function (box, token) {
                        $(form.formUploadBoxes).each(function (ii, bb) {
                            if (bb.box.id == box.id) {
                                bb.uploaded = true;
                                $('*[data-progress-bar-box]', $(bb.box)).hide();
                            }
                        });
                        form.checkUploadsAndSubmit();
                    };
                    fub.box.submit(form.token);
                }
            });
            form.checkUploadsAndSubmit();
        });

        form.checkUploadsAndSubmit = function () {
            var done = true;
            var t = new Array();
            $(this.formUploadBoxes).each(function (index, fub) {
                t.push(fub.uploaded);
                if (!fub.uploaded)
                    done = false;
            });
            if (done) {
                var code = $(this).data('code');
                var reqData = { code: code, data: JSON.stringify(this.getConfig()), token: this.token };
                this.submit(reqData);
            }
        };
    });
};

var hookAjaxFormsFn = function ($ajaxForms) {

    $ajaxForms.each(function(i, form) {

        var $form = $(form);

        form.methodType = $form.data('method');
        form.submitUrl = $form.data('action');
        $form.removeAttr('data-action');

        var $rows = $('*.form-row.text, *.form-row.textarea, *.form-row.checkbox, *.form-row.select', $form);

        form.back = function() {
            $('*[data-section]', $(form)).hide();
            $('*[data-section="content"]', $(form)).show();
        };

        form.getConfig = function() {
            var config = {};
            $rows.each(function(r, row) {
                var $valField = $('*[data-member]:first', $(row));
                if ($valField.length > 0)
                    config[$valField.data('member')] = row.getValue();
            });
            $('*[data-hidden-member]', $(form)).each(function(i, item) {
                config[$(item).data('hidden-member')] = $(item).val();
            });

            if (form.methodType === 'control') {
                return [
                    config
                ];
            }
            else {
                return config;
            }
        };

        form.onSuccess = function(request, response) {

            var redirectUrl = $(this).data('redirect');
            if (redirectUrl === undefined) {
                $('*[data-validator]', $(form)).hide();
                $('*[data-validationmsg]', $(form)).hide();
                $('.file-uploader', $(form)).hide();

                var $successSection = $('*[data-section="success"]', $(form));
                if ($successSection.length > 0) {
                    var $sections = $('*[data-section]', $(form));
                    $sections.hide();

                    var successMsgVal = $('*[data-validationmsg="success"]', $successSection);
                    successMsgVal.html(LhApp.Function.getText('Validation:' + response.code));
                    successMsgVal.show();
                    $successSection.show();
                } else {
                    var successMsgVal = $('*[data-section="content"] *[data-validationmsg="success"]', $(form));
                    successMsgVal.html(LhApp.Function.getText('Validation:' + response.code));
                    successMsgVal.show();
                }
            } else if (redirectUrl != '') {
                document.location = redirectUrl;
            }
        };

        form.onFailure = function(request, response) {
            var validationMessage = LhApp.Function.getText('Validation:' + response.code);

            $('*[data-validator]', $(form)).hide();
            $('*[data-validationmsg]', $(form)).hide();
            var $failureSection = $('*[data-section="failure"]', $(form));
            if ($failureSection.length > 0) {
                var $sections = $('*[data-section]', $(form));
                $sections.hide();
                $failureSection.show();

                var $validator = $('*[data-validationmsg="failure"]', $failureSection);
                $validator.html(validationMessage);
                $validator.show();
            } else {
                var $validator = $('*[data-section="content"]  *[data-validationmsg="failure"]', $(form));
                if ($validator.length > 0) {
                    $validator.html(validationMessage);
                    $validator.show();
                } else {
                    var $validator = $('*[data-validationmsg]', $(form));
                    $validator.html(validationMessage);
                    $validator.show();
                }
            }
        };

        form.submit = function(config) {
            var me = this;

            if (form.isLoading())
                return;

            me.showLoader();

            var successFn = function (response) {
                me.hideLoader();

                var responseData = form.methodType == 'control' ? jQuery.parseJSON(response) : response.d;

                if (responseData.Success) responseData.success = responseData.Success;
                if (responseData.Code) responseData.code = responseData.Code;
                if (responseData.data) responseData.data = responseData.Data;
                if (responseData.time) responseData.time = responseData.Time;

                if (!responseData.success && responseData.code == 'GenericError') {
                    if (typeof (responseData.Data) == 'string') {
                        try {
                            responseData.Data = jQuery.parseJSON(responseData.Data);
                        } catch (e) {
                        }
                    }
                }

                if (responseData.success && typeof (me.onSuccess) === 'function')
                    me.onSuccess(config, responseData);
                else if (!responseData.success && typeof (me.onFailure) === 'function')
                    me.onFailure(config, responseData);
            };

            var failureFn = function (ex) {
                me.hideLoader();

                var response = {
                    code: 'GenericError',
                    success: false,
                    time: 0
                };

                if (ex.responseText)
                    response.data = jQuery.parseJSON(ex.responseText)
                else
                    response.data = ex;

                if (typeof (me.onFailure) === 'function')
                    me.onFailure(config, response);
            };

            if (form.methodType === 'control') { // todo: is this used??
                form.invoke(form.config, form.submitUrl, form.methodType == 'control' ? config : JSON.stringify(config), successFn, failureFn);
            }
            else {
                $.ajax({
                    async: true,
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    ContentType: 'application/json; charset=UTF-8',
                    url: LhApp.Function.Url.getServiceEndpoint(me.submitUrl),
                    data: JSON.stringify(config),
                    success: successFn,
                    error: failureFn,
                    failure: failureFn
                });
            }
        };

        $('*[data-section="failure"] *[data-click="reset"]', $(form)).click(function(e) {
            e.preventDefault();

            var isDisabled = form.isLoading() || LhApp.Function.isButtonDisabled(this);
            if (isDisabled)
                return;

            form.reset();
            form.back();
        });
    });
};

Vendd.Scripts.load(function() {
    var $forms = $('.x-control.x-form[data-control="form"]');
    var $ajaxForms = $('.x-control.x-form[data-control="form"][data-ajax="true"]');

    hookFormsFn($forms);
    hookAjaxFormsFn($ajaxForms);

    if (venddProjectConfigs.convertToGreek)
        convertToGreek();

    if (venddProjectConfigs.convertToUppercase)
        convertToUppercase();
});


